module.exports = __webpack_public_path__ + "img/iconIG.f37c7132.svg";